define(["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $('#page-id').focus(function (event) {
        $(event.target).select();
    });
});
